<!-- eslint-disable max-len -->
<nz-tabset
  nzCentered
  (nzSelectedIndexChange)="onChangeTab($event)"
  qa="editWindow"
>
  <nz-tab nzTitle="General"> </nz-tab>
  <nz-tab nzTitle="Endpoint & Stats"> </nz-tab>
  <nz-tab nzTitle="Schain Settings"> </nz-tab>
  <nz-tab nzTitle="Filters & Scanners"> </nz-tab>
  <nz-tab nzTitle="Others"> </nz-tab>
</nz-tabset>
<form class="dsp-form-edit" [formGroup]="editDspService.editDSPForm">
  <div class="platform-form endpoint-edit-form">
    <div class="card-container">
      <div class="row" *ngIf="editDspService.tabIndex === 0">
        <div class="col-6">
          <div class="form-group">
            <label for="endpointNameDSPEdit">Name *</label>
            <input
              nz-input
              type="text"
              id="endpointNameDSPEdit"
              name="name"
              required
              formControlName="name"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label class="label-title">Connection Type</label>
            <div class="conn-type">
              <div
                class="item active"
                *ngIf="editDspService.formValue['connectionType'] === 0"
              >
                RTB
              </div>
              <div
                class="item active"
                *ngIf="editDspService.formValue['connectionType'] === 1"
              >
                VAST
              </div>
              <div
                class="item active"
                *ngIf="editDspService.formValue['connectionType'] === 3"
              >
                JS
              </div>
              <div
                class="item active"
                *ngIf="editDspService.formValue['connectionType'] === 4"
              >
                Prebid
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="editDspService.isRtbConnection()">
            <label>RTB Connection</label>
            <div class="btn-group btn-group--rtb">
              <label
                [class.active]="
                  editDspService.formValue.rtbConnectionMode === 0
                "
              >
                RTB to ALL
                <input
                  type="radio"
                  formControlName="rtbConnectionMode"
                  [checked]="editDspService.formValue.rtbConnectionMode === 0"
                  [value]="0"
                />
              </label>
              <label
                [class.active]="
                  editDspService.formValue.rtbConnectionMode === 2
                "
              >
                RTB to RTB
                <input
                  type="radio"
                  formControlName="rtbConnectionMode"
                  [checked]="editDspService.formValue.rtbConnectionMode === 2"
                  [value]="2"
                />
              </label>
              <label
                [class.active]="
                  editDspService.formValue.rtbConnectionMode === 1
                "
              >
                RTB to VAST
                <input
                  type="radio"
                  formControlName="rtbConnectionMode"
                  [checked]="editDspService.formValue.rtbConnectionMode === 1"
                  [value]="1"
                />
              </label>
              <label
                [class.active]="
                  editDspService.formValue.rtbConnectionMode === 3
                "
              >
                RTB to JS
                <input
                  type="radio"
                  formControlName="rtbConnectionMode"
                  [checked]="editDspService.formValue.rtbConnectionMode === 3"
                  [value]="3"
                />
              </label>
            </div>
          </div>
          <div class="form-group" *ngIf="editDspService.isVastConnection()">
            <label>VAST Connection</label>
            <div class="btn-group btn-group--vast">
              <label
                [class.active]="
                  editDspService.formValue.vastConnectionMode === 0
                "
              >
                VAST to ALL
                <input
                  type="radio"
                  formControlName="vastConnectionMode"
                  [value]="0"
                  [checked]="editDspService.formValue.vastConnectionMode === 0"
                />
              </label>
              <label
                [class.active]="
                  editDspService.formValue.vastConnectionMode === 2
                "
              >
                VAST to RTB
                <input
                  type="radio"
                  formControlName="vastConnectionMode"
                  [value]="2"
                  [checked]="editDspService.formValue.vastConnectionMode === 2"
                />
              </label>
              <label
                [class.active]="
                  editDspService.formValue.vastConnectionMode === 1
                "
              >
                VAST to VAST
                <input
                  type="radio"
                  formControlName="vastConnectionMode"
                  [value]="1"
                  [checked]="editDspService.formValue.vastConnectionMode === 1"
                />
              </label>
            </div>
          </div>

          <div class="form-group" *ngIf="editDspService.isRtbConnection()">
            <label>OpenRTB Version</label>
            <nz-select
              nzShowSearch
              nzPlaceHolder="Select OpenRTB Version"
              formControlName="rtb_type"
              name="rtb_type"
            >
              <nz-option
                *ngFor="let version of editDspService.rtbVersions"
                [nzValue]="version.id"
                [nzLabel]="version.name"
              ></nz-option>
            </nz-select>
          </div>

          <div
            class="form-group"
            *ngIf="
              editDspService.isRtbConnection() ||
              editDspService.isPreBidConnection()
            "
          >
            <div class="hub-row">
              <div class="hub-part" qa="additionalSettings">
                <div class="check-tooltip">
                  <label
                    checkboxLabel="useAdapterDSPEdit"
                    nz-checkbox
                    formControlName="useAdapter"
                    name="useAdapter"
                    (ngModelChange)="onChangeQPSAdapter($event)"
                    >QPS Adapter</label
                  >
                  <app-tooltip
                    [tooltipTitle]="
                      'Activates QPS adapter, which allocates the most relevant traffic to be sent to the DSP endpoint according to its bidding activity'
                    "
                  ></app-tooltip>
                </div>
              </div>
            </div>
          </div>
          <hr
            *ngIf="
              editDspService.isRtbConnection() ||
              editDspService.isPreBidConnection()
            "
          />
          <div
            class="form-group"
            *ngIf="
              editDspService.formValue.useAdapter &&
              (editDspService.isRtbConnection() ||
                editDspService.isPreBidConnection())
            "
          >
            <label class="label-title" for="minRcpmDSPEdit"
              >Min RCPM
              <app-tooltip
                [tooltipTitle]="
                  'The minimum required RCPM for the endpoint, the system would count it as a minimum effective for the endpoint'
                "
              ></app-tooltip>
            </label>
            <input
              nz-input
              type="number"
              class="form-control"
              id="minRcpmDSPEdit"
              name="min_rcpm"
              formControlName="min_rcpm"
            />
          </div>
          <div
            *ngIf="
              editDspService.isVastConnection() ||
              editDspService.isJSConnection()
            "
            class="form-group"
          >
            <div class="hub-row">
              <div class="hub-part">
                <div class="check-tooltip">
                  <label
                    checkboxLabel="useAdapterDSPEdit"
                    nz-checkbox
                    formControlName="useAdapter"
                    name="useAdapter"
                    >QPS Adapter</label
                  >
                </div>
              </div>
            </div>
          </div>
          <hr *ngIf="editDspService.isVastConnection()" />
          <div
            *ngIf="
              editDspService.isPreBidConnection() ||
              editDspService.isRtbConnection()
            "
          >
            <div class="form-title form-title--checkbox">Ad Format</div>
            <div class="form-group">
              <div class="custom-checkbox" id="adFormat">
                <div class="checkbox">
                  <label
                    checkboxLabel="bannerFormatDSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="banner"
                    name="banner"
                    >Banner
                  </label>
                </div>
                <div class="checkbox-with-drop">
                  <div class="checkbox">
                    <label
                      checkboxLabel="nativeFormatDSPEdit"
                      nz-checkbox
                      [ngClass]="
                        editDspService.isRequiredAdFormat
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="native"
                      (ngModelChange)="onChangeNative($event)"
                      name="native"
                      >Native
                    </label>
                  </div>
                  <div
                    class="format-group"
                    *ngIf="editDspService.formValue['native']"
                  >
                    <app-select-multi-antd-control
                      [items]="editDspService.nativeVersions"
                      [selectedItems]="editDspService.nativeSpecControl.value"
                      [control]="editDspService.nativeSpecControl"
                      [placeholder]="'Choose Item'"
                      id="native"
                    >
                    </app-select-multi-antd-control>
                  </div>
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="videoFormatDSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="video"
                    name="video"
                    >Video</label
                  >
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="rewardedFormatDSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    formControlName="rewarded"
                    [nzDisabled]="editDspService.formValue['audio']"
                    name="rewarded"
                    >Rewarded video
                  </label>
                </div>
                <div class="checkbox">
                  <label
                    checkboxLabel="audioFormatDSPEdit"
                    nz-checkbox
                    [ngClass]="
                      editDspService.isRequiredAdFormat
                        ? 'required-label'
                        : 'fake-label'
                    "
                    *ngIf="editDspService.isRtbConnection()"
                    formControlName="audio"
                    [nzDisabled]="
                      editDspService.formValue['ctv'] ||
                      editDspService.formValue['rewarded']
                    "
                    name="audio"
                    >Audio
                  </label>
                </div>
              </div>
            </div>
          </div>
          <hr
            *ngIf="
              editDspService.isPreBidConnection() ||
              editDspService.isRtbConnection()
            "
          />
          <div
            class="form-title form-title--traffic"
            *ngIf="
              editDspService.isRtbConnection() ||
              editDspService.isPreBidConnection()
            "
          >
            Traffic type
          </div>
          <div
            class="form-group"
            *ngIf="
              editDspService.isRtbConnection() ||
              editDspService.isPreBidConnection()
            "
          >
            <div class="custom-checkbox" id="trafficType">
              <div class="checkbox">
                <label
                  checkboxLabel="mobileWebTrafficTypeDSPEdit"
                  nz-checkbox
                  [ngClass]="
                    editDspService.isRequiredTrafficType
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="mobileWeb"
                  name="mobileWeb"
                  >Mobile web
                </label>
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="mobileAppTrafficTypeDSPEdit"
                  nz-checkbox
                  [ngClass]="
                    editDspService.isRequiredTrafficType
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="inApp"
                  name="inApp"
                  >Mobile app
                </label>
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="desktopTrafficTypeDSPEdit"
                  nz-checkbox
                  [ngClass]="
                    editDspService.isRequiredTrafficType
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="desktop"
                  name="desktop"
                  >Desktop
                </label>
              </div>
              <div class="checkbox">
                <label
                  checkboxLabel="ctvTrafficTypeDSPEdit"
                  nz-checkbox
                  [ngClass]="
                    editDspService.isRequiredTrafficType
                      ? 'required-label'
                      : 'fake-label'
                  "
                  formControlName="ctv"
                  [nzDisabled]="editDspService.formValue['audio']"
                  name="ctv"
                  >CTV
                </label>
              </div>
            </div>
          </div>
          <hr
            *ngIf="
              editDspService.isPreBidConnection() ||
              editDspService.isRtbConnection()
            "
          />
          <div *ngIf="editDspService.isVastConnection()">
            <div class="form-title form-title--checkbox">Ad Format</div>
            <div class="form-group">
              <div class="hub-row">
                <div class="hub-part" id="adFormat">
                  <div class="checkbox">
                    <label
                      checkboxLabel="videoFormatVastDSPEdit"
                      nz-checkbox
                      [ngClass]="
                        editDspService.isRequiredAdFormat
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="video"
                      [nzDisabled]="
                        editDspService.formValue['audio'] ||
                        editDspService.formValue['rewarded']
                      "
                      name="video"
                      >Video</label
                    >
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="rewardedFormatVastDSPEdit"
                      nz-checkbox
                      [ngClass]="
                        editDspService.isRequiredAdFormat
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="rewarded"
                      name="rewarded"
                      [nzDisabled]="
                        editDspService.formValue['video'] ||
                        editDspService.formValue['audio']
                      "
                      >Rewarded video</label
                    >
                  </div>
                  <div class="checkbox">
                    <label
                      checkboxLabel="audioFormatVastDSPEdit"
                      nz-checkbox
                      [ngClass]="
                        editDspService.isRequiredAdFormat
                          ? 'required-label'
                          : 'fake-label'
                      "
                      formControlName="audio"
                      [nzDisabled]="
                        editDspService.formValue['video'] ||
                        editDspService.formValue['rewarded']
                      "
                      name="audio"
                      >Audio</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr
            *ngIf="
              editDspService.isVastConnection() ||
              editDspService.isJSConnection()
            "
          />
          <div
            class="form-group form-radio"
            *ngIf="editDspService.isVastConnection()"
            id="trafficType"
          >
            <label class="form-title form-title--traffic"
              >Traffic Type
              <app-tooltip
                [tooltipTitle]="
                  'Choose whether the endpoint works according to RTB specifications or VAST.'
                "
              ></app-tooltip>
            </label>
            <div class="ad-types">
              <div class="radio-50">
                <label
                  class="custom-radio"
                  checkboxLabel="mobileWebVastTrafficTypeDSPEdit"
                >
                  Mobile web
                  <input
                    formControlName="adtype"
                    type="radio"
                    name="adtype"
                    value="mobileWeb"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="radio-50">
                <label
                  class="custom-radio"
                  checkboxLabel="desktopVastTrafficTypeDSPEdit"
                >
                  Desktop
                  <input
                    formControlName="adtype"
                    type="radio"
                    name="adtype"
                    value="desktop"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="ad-types">
              <div class="radio-50">
                <label
                  class="custom-radio"
                  checkboxLabel="mobileAppVastTrafficTypeDSPEdit"
                >
                  Mobile app
                  <input
                    formControlName="adtype"
                    type="radio"
                    name="adtype"
                    value="inApp"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="radio-50">
                <label
                  class="custom-radio ml-20"
                  checkboxLabel="ctvVastTrafficTypeDSPEdit"
                >
                  CTV
                  <input
                    formControlName="adtype"
                    type="radio"
                    formControlName="adtype"
                    name="adtype"
                    value="ctv"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div
            class="form-group form-radio"
            *ngIf="editDspService.isJSConnection()"
            id="trafficType"
          >
            <label
              >Traffic Type
              <app-tooltip
                [tooltipTitle]="
                  'Choose whether the endpoint works according to RTB specifications or VAST.'
                "
              ></app-tooltip>
            </label>
            <div class="ad-types">
              <div class="radio-50">
                <label
                  class="custom-radio"
                  checkboxLabel="mobileWebJSTrafficTypeDSPEdit"
                >
                  Mobile web
                  <input
                    formControlName="jsAdType"
                    type="radio"
                    name="jsAdType"
                    value="mobileWeb"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="radio-50">
                <label
                  class="custom-radio"
                  checkboxLabel="desktopJSTrafficTypeDSPEdit"
                >
                  Desktop
                  <input
                    formControlName="jsAdType"
                    type="radio"
                    name="jsAdType"
                    value="desktop"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="ad-types">
              <div class="radio-50">
                <label
                  class="custom-radio"
                  checkboxLabel="mobileAppJSTrafficTypeDSPEdit"
                >
                  Mobile app
                  <input
                    formControlName="jsAdType"
                    type="radio"
                    name="jsAdType"
                    value="inApp"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="label-title"
              >Company*
              <app-tooltip
                [tooltipTitle]="'A company to which endpoint belongs'"
              ></app-tooltip>
            </label>
            <nz-select
              [ngClass]="
                editDspService.isRequiredCompany
                  ? 'required-company'
                  : 'company'
              "
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Company"
              (ngModelChange)="onCompanyChange()"
              formControlName="companyId"
              name="companyId"
            >
              <nz-option
                *ngFor="let company of editDspService.companies"
                [nzValue]="company.id"
                [nzLabel]="company.name"
              >
              </nz-option>
            </nz-select>
          </div>
          <div class="form-group">
            <label class="label-title"
              >Region*
              <app-tooltip
                [tooltipTitle]="'Region in which server capacities are located'"
              ></app-tooltip>
            </label>
            <nz-select
              [nzDisabled]="true"
              [ngClass]="
                editDspService.isRequiredRegion ? 'required-region' : 'region'
              "
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Region"
              formControlName="region"
              name="region"
            >
              <nz-option
                *ngFor="let region of editDspService.regions"
                [nzValue]="region.id"
                [nzLabel]="region.name"
              ></nz-option>
            </nz-select>
          </div>
          <div class="form-group">
            <label for="margin_type">Margin Type</label>
            <div class="margin-group">
              <nz-radio-group
                formControlName="margin_type"
                name="margin_type"
                nzButtonStyle="solid"
                (ngModelChange)="onChangeMarginType($event)"
              >
                <label nz-radio-button nzValue="fixed">Fixed</label>
                <label
                  nz-radio-button
                  nzValue="adaptive"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editDspService.restrictionTooltipMessage(
                      'Adaptive margin type'
                    )
                  "
                  nzTooltipPlacement="top"
                  [nzDisabled]="
                    editDspService.partnerSettings.partner_plan === 3
                  "
                  >Adaptive</label
                >
                <label
                  nz-radio-button
                  nzValue="range"
                  nz-tooltip
                  nzTooltipOverlayClassName="item-tooltip"
                  [nzTooltipTitle]="
                    editDspService.restrictionTooltipMessage(
                      'Range margin type'
                    )
                  "
                  nzTooltipPlacement="top"
                  [nzDisabled]="
                    editDspService.partnerSettings.partner_plan === 3
                  "
                  >Range</label
                >
              </nz-radio-group>
            </div>
            <div
              class="margin"
              *ngIf="editDspService.formValue['margin_type'] === 'fixed'"
            >
              <div class="form-group">
                <label class="label-title" for="marginDSPEdit"
                  >Margin*
                  <app-tooltip
                    [tooltipTitle]="
                      'Percent that the platform charges from the endpoint revenue'
                    "
                  ></app-tooltip>
                </label>
                <input
                  class="form-control"
                  nz-input
                  type="number"
                  id="marginDSPEdit"
                  name="margin"
                  min="0"
                  max="100"
                  formControlName="margin"
                  placeholder="15 %"
                  required
                />
              </div>
            </div>
            <div
              class="adavanced-settings"
              *ngIf="editDspService.formValue['margin_type'] === 'range'"
            >
              <div class="clearfix">
                <div class="part left alt">
                  <div class="form-group">
                    <label for="minMarginDSPEdit">Min Margin*</label>
                    <input
                      class="form-control"
                      nz-input
                      type="number"
                      id="minMarginDSPEdit"
                      name="min_margin"
                      min="1"
                      max="100"
                      formControlName="min_margin"
                      placeholder="1 %"
                      required
                    />
                  </div>
                </div>
                <div class="part right alt">
                  <div class="form-group">
                    <label for="maxMarginDSPEdit">Max Margin*</label>
                    <input
                      class="form-control"
                      nz-input
                      type="number"
                      id="maxMarginDSPEdit"
                      name="max_margin"
                      min="1"
                      max="100"
                      formControlName="max_margin"
                      placeholder="100 %"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="editDspService.isVastConnection()">
            <label class="label-title" for="defaultPriceVastDSPEdit"
              >Fixed Price *
              <app-tooltip
                tooltipTitle="The value entered here is used as the fixed payout to DSP partners. This value represents the cost per thousand impressions (CPM)"
              ></app-tooltip>
            </label>
            <input
              nz-input
              class="form-control"
              required
              type="number"
              min="0"
              id="defaultPriceVastDSPEdit"
              name="defaultPriceVast"
              formControlName="defaultPriceVast"
            />
          </div>
          <div
            class="form-group"
            *ngIf="editDspService.isJSConnection()"
            formGroupName="js"
          >
            <label for="cpmcpmDSPEdit">
              Fixed CPM *
              <app-tooltip
                tooltipTitle="The value entered here is used as the fixed payout to DSP partners. This value represents the cost per thousand impressions (CPM)"
              ></app-tooltip>
            </label>
            <input
              nz-input
              class="form-control"
              required
              numeric
              formControlName="cpm"
              name="cpm"
              id="cpmDSPEdit"
            />
          </div>
          <div class="form-group">
            <label class="label-title" for="spendLimitDSPEdit"
              >Spend Limit<span *ngIf="editDspService.isJSConnection()">*</span>
              <app-tooltip
                [tooltipTitle]="'Maximum spend from this endpoint.'"
              ></app-tooltip>
            </label>
            <div class="dsp-limit">
              <input
                nz-input
                type="number"
                class="form-control"
                id="spendLimitDSPEdit"
                name="spendLimit"
                [required]="editDspService.isJSConnection()"
                formControlName="spendLimit"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="label-title" for="limitQPSDSPEdit"
              >QPS Limit*
              <app-tooltip
                [tooltipTitle]="
                  'Maximum allowed queries per second this endpoint can handle'
                "
              ></app-tooltip>
            </label>
            <div class="">
              <input
                nz-input
                type="number"
                class="form-control"
                id="limitQPSDSPEdit"
                name="limitQPS"
                formControlName="limitQPS"
              />
            </div>
          </div>
          <div
            class="form-group"
            *ngIf="
              editDspService.isRtbConnection() ||
              editDspService.isPreBidConnection()
            "
          >
            <label
              >Auction Type
              <app-tooltip
                [tooltipTitle]="
                  'Optimized model - auction will be presented for your partners as at:2, but in fact aims to generate more earnings for you'
                "
              ></app-tooltip>
            </label>
            <nz-select
              nzShowSearch
              nzPlaceHolder="Select Auction Type"
              formControlName="auctionType"
              name="auctionType"
            >
              <nz-option
                *ngFor="let auction of editDspService.auctionTypes"
                [nzValue]="auction.id"
                [nzLabel]="auction.name"
              >
              </nz-option>
            </nz-select>
          </div>
          <div class="form-group">
            <label class="label-title" for="minTmax"
              >Min tmax
              <app-tooltip
                [tooltipTitle]="'Minimum allowed tmax in the request'"
              ></app-tooltip>
            </label>
            <input
              nz-input
              class="form-control"
              id="minTmaxDSPEdit"
              name="minTmax"
              formControlName="minTmax"
            />
          </div>
          <div class="adavanced-settings-wrap">
            <div>
              <div class="row b-row">
                <div
                  class="col-6"
                  *ngIf="
                    editDspService.isRtbConnection() ||
                    editDspService.isPreBidConnection()
                  "
                >
                  <div class="form-group">
                    <label for="min_bidfloor_replacement">
                      Min Bidfloor
                      <app-tooltip
                        tooltipTitle="Min Bidfloor Replacement
                        If the final bidfloor is below this value, it will be increased to match the configured minimum before being sent to the DSP.

                        If the final bidfloor is equal to or higher, it’s passed as is.

                        This setting does not drop requests - it ensures low bidfloors are adjusted to match the minimum value."
                      ></app-tooltip>
                    </label>
                    <input
                      nz-input
                      type="number"
                      min="0"
                      class="form-control"
                      id="minBidfloorReplacementDSPEdit"
                      name="min_bidfloor_replacement"
                      formControlName="min_bidfloor_replacement"
                    />
                  </div>
                </div>
                <div
                  [ngClass]="
                    editDspService.isRtbConnection() ||
                    editDspService.isPreBidConnection()
                      ? 'col-6'
                      : 'col-12'
                  "
                >
                  <div class="form-group">
                    <label for="maxBidfloor">Max Bidfloor</label>
                    <input
                      nz-input
                      type="number"
                      class="form-control"
                      id="maxBidfloor"
                      name="maxBidfloorDSPEdit"
                      formControlName="maxBidfloor"
                      qa="bidfloor"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="editDspService.isJSConnection()">
            <hr />
            <div class="form-title form-title--size">Size</div>
            <div class="form-group">
              <label>Size</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Choose Size"
                formControlName="selectedSize"
                (ngModelChange)="onChangeSize($event)"
                name="size-select"
              >
                <nz-option
                  *ngFor="let item of editDspService.listOfSizes"
                  [nzValue]="item.id"
                  [nzLabel]="item.name"
                ></nz-option>
              </nz-select>
            </div>
            <div class="form-group" formGroupName="js">
              <div class="row b-row dsp-api-link-wrap">
                <div class="col-6">
                  <label>Width*</label>
                  <input
                    id="customWidthJSDSPEdit"
                    nz-input
                    type="number"
                    name="w"
                    formControlName="w"
                    required
                    class="form-control"
                  />
                </div>
                <div class="col-6">
                  <label>Height*</label>
                  <input
                    id="customHeightJSDSPEdit"
                    nz-input
                    type="number"
                    name="h"
                    formControlName="h"
                    required
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="row" *ngIf="editDspService.tabIndex === 1">
        <div class="col-12">
          <div
            class="endpoint-link"
            *ngIf="!editDspService.isPreBidConnection()"
          >
            <div class="row b-row dsp-api-link-wrap">
              <div class="col-9">
                <div class="form-group">
                  <label for="test-api-link">{{
                    editDspService.connectionTypesNamesDSP[
                      editDspService.formValue.connectionType
                    ]
                  }}</label>
                  <textarea
                    nz-input
                    class="form-control"
                    (change)="onEndpointChange($event)"
                    formControlName="endpoint"
                    name="endpoint"
                    required
                  ></textarea>
                </div>
              </div>
              <div class="col-3">
                <div class="flex-buttons">
                  <button
                    *ngIf="!editDspService.isJSConnection()"
                    class="button"
                    nz-button
                    nzType="primary"
                    (click)="
                      onEndpointUrlTest(
                        editDspService.formValue.endpoint,
                        $event
                      )
                    "
                    [disabled]="editDspService.isDisabledTest"
                  >
                    Test
                  </button>
                  <button
                    buttonLabel="copyEndpointDSPEdit"
                    nz-button
                    nzType="primary"
                    class="button"
                    type="button"
                    (click)="onLinkCopy($event, 'Copy endpoint')"
                    [cbContent]="editDspService.formValue['endpoint']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row b-row dsp-api-link-wrap"
            *ngIf="
              editDspService.isJSConnection() ||
              editDspService.isVastConnection()
            "
            Ï
          >
            <div style="padding-bottom: 10px">
              <button
                class="macros-list-button"
                nz-button
                nzType="default"
                (click)="showMacrosList()"
              >
                Macros List
              </button>
            </div>
          </div>

          <div class="col-12">
            <app-validate-endpoint-url
              [endpointUrl]="editDspService.endpointUrl"
              [endpointValidationStatuses]="
                editDspService.apiLinkValidationStatus
              "
              [region]="editDspService.formValue.region"
              [type]="'default'"
            ></app-validate-endpoint-url>
          </div>

          <div
            *ngIf="
              editDspService.isPreBidConnection() && editDspService.preBidItem
            "
          >
            <div class="form-group">
              <label>Prebid Server</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select PreBid Server"
                formControlName="adapter_id"
                (ngModelChange)="onChangePreBidServer($event)"
                name="preBidServers"
              >
                <nz-option
                  *ngFor="let server of editDspService.serversPreBid"
                  [nzValue]="server.id"
                  [nzLabel]="server.name"
                  [nzDisabled]="
                    editDspService.getIsDisabledPreBidOption(server.name)
                  "
                  nzCustomContent
                >
                  <span
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editDspService.getTooltipForPreBidServer(server.name)
                    "
                    nzTooltipPlacement="top"
                    >{{ server.name }}
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div class="block-fields" *ngIf="editDspService.isShowFields">
              <h3 class="prebid-header">Additional Prebid Fields</h3>
              <div
                class="form-group"
                *ngFor="let item of editDspService.serverPreBid; let i = index"
              >
                <span *ngIf="item.type !== 'boolean'">
                  <label
                    >{{ item.name }}
                    <span
                      *ngIf="editDspService.isRequiredPreBidField(item.name)"
                    >
                      *
                    </span>
                    <app-tooltip
                      *ngIf="item.tooltip"
                      [tooltipTitle]="item.tooltip"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    [name]="getDynamicNameForField(item.name)"
                    (input)="onChangeInput($event)"
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="editDspService.isRequiredPreBidField(item.name)"
                  />
                </span>
                <div *ngIf="item.type === 'boolean'" class="check-tooltip">
                  <label
                    nz-checkbox
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    {{ item.name }}
                  </label>
                  <app-tooltip
                    *ngIf="item.tooltip"
                    [tooltipTitle]="item.tooltip"
                  ></app-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              editDspService.isRtbConnection() && editDspService.adaptersItem
            "
          >
            <div class="form-group">
              <label>
                Custom Adapter
                <app-tooltip [tooltipTitle]="'API adapters list'"></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Custom Adapter"
                formControlName="adapter_id"
                (ngModelChange)="onChangeCustomAdapter($event)"
                name="customAdapter"
              >
                <nz-option
                  *ngFor="let adapter of editDspService.rtbAdapters"
                  [nzValue]="adapter.id"
                  [nzLabel]="adapter.name"
                  [nzDisabled]="isDisabledOption(adapter.name)"
                  nzCustomContent
                >
                  <span
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editDspService.getTooltipForAdapter(adapter.name)
                    "
                    nzTooltipPlacement="top"
                    >{{ adapter.name }}
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div class="block-fields" *ngIf="editDspService.isShowFields">
              <div class="prebid-header">Additional Adapters Fields</div>
              <div
                class="form-group"
                *ngFor="let item of editDspService.adaptersRtb; let i = index"
              >
                <label class="label-title"
                  >{{ item.name }}
                  <span *ngIf="isRequiredAdapterField(item.name)"> * </span>
                  <app-tooltip
                    *ngIf="item.tooltip"
                    [tooltipTitle]="item.tooltip"
                  ></app-tooltip>
                </label>
                <ng-container
                  [ngSwitch]="item.parentName === 'Custom Extensions'"
                >
                  <textarea
                    *ngSwitchCase="true"
                    nz-input
                    class="form-control"
                    [(ngModel)]="item.field"
                    (input)="
                      onChangeRtbAdapterField($event, item.field, item.name)
                    "
                    [ngModelOptions]="{ standalone: true }"
                    [required]="isRequiredAdapterField(item.name)"
                  ></textarea>
                  <input
                    *ngSwitchCase="false"
                    nz-input
                    class="form-control"
                    (input)="
                      onChangeRtbAdapterField($event, item.field, item.name)
                    "
                    [(ngModel)]="item.field"
                    [ngModelOptions]="{ standalone: true }"
                    [required]="isRequiredAdapterField(item.name)"
                    name="field"
                    [disabled]="item.disabled"
                  />
                </ng-container>
              </div>
            </div>

            <div *ngIf="editDspService.isFreewheelAdapter">
              <div class="switch-wrap__row freewheel-keywords-wrap">
                <div
                  class="switch-wrap__column column-switch"
                  style="justify-content: space-between"
                >
                  <div class="column-switch__label">
                    <span>FreeWheel Keywords</span>
                    <div class="icon">
                      <app-tooltip
                        tooltipTitle="When enabled, additional keyword-specific input fields become available. Values entered in these fields can be injected into the request as a fallback if the corresponding values are not present in the incoming request.
                        The system always parses keyword values from the request first, regardless of this setting, and uses the UI input only if no matching value is found."
                      ></app-tooltip>
                    </div>
                  </div>
                  <div class="column-switch__switch">
                    <nz-switch
                      [(ngModel)]="editDspService.isFreewheelKeywordsEnabled"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="
                        editDspService.onFreewheelKeywordsToggleHandler($event)
                      "
                    ></nz-switch>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="editDspService.isFreewheelKeywordsEnabled">
                <div class="form-group">
                  <label class="label-title">
                    Timezone
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_timezone field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: -05:00"
                    [(ngModel)]="editDspService.freewheelKeywordsData.timezone"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    City
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_city field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: Phoenix"
                    [(ngModel)]="editDspService.freewheelKeywordsData.city"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    DMA
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_dma field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: 501"
                    [(ngModel)]="editDspService.freewheelKeywordsData.dma"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    State
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_h_x_state field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: Arizona"
                    [(ngModel)]="editDspService.freewheelKeywordsData.state"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Programmer Brand
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_programmer_brand field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: Disney"
                    [(ngModel)]="
                      editDspService.freewheelKeywordsData.programmer_brand
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Channel
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_programmer_brand_channel field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: ESPN"
                    [(ngModel)]="editDspService.freewheelKeywordsData.channel"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Genre
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_genre field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: genre 1, genre 2"
                    [(ngModel)]="editDspService.freewheelKeywordsData.genre"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Language
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_language field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: en, es"
                    [(ngModel)]="editDspService.freewheelKeywordsData.language"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Content Rating
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_rating field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: TV-PG"
                    [(ngModel)]="
                      editDspService.freewheelKeywordsData.content_rating
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Content Stream Mode
                    <app-tooltip
                      tooltipTitle="Corresponds to _fw_content_stream_mode field"
                    ></app-tooltip>
                  </label>
                  <input
                    nz-input
                    class="form-control"
                    placeholder="Example: live"
                    [(ngModel)]="
                      editDspService.freewheelKeywordsData.content_stream_mode
                    "
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group">
                  <label class="label-title">
                    Custom Key-Value Pair
                    <app-tooltip
                      tooltipTitle="Allows adding custom fields to the keywords object. Enter the field name in the first field and its value in the second (multiple values can be separated by commas). For formatting details, please consult the FreeWheel team."
                    ></app-tooltip>
                  </label>
                  <div class="freewheel-kv-wrapper">
                    <ng-container
                      *ngFor="
                        let pair of editDspService.freewheelKeyValuePairs;
                        let i = index
                      "
                    >
                      <div class="freewheel-kv-block">
                        <div *ngIf="i > 0" class="freewheel-kv-optional-label">
                          <span>Optional keywords fields</span>
                          <button
                            class="freewheel-kv-remove-btn"
                            (click)="
                              editDspService.removeFreewheelKeyValuePair(i)
                            "
                          >
                            Remove
                            <span
                              nz-icon
                              nzType="delete"
                              nzTheme="outline"
                            ></span>
                          </button>
                        </div>
                        <div class="freewheel-kv-inputs">
                          <input
                            nz-input
                            class="form-control"
                            placeholder="objectname"
                            [(ngModel)]="pair.key"
                            [ngModelOptions]="{ standalone: true }"
                            nz-tooltip
                            nzTooltipOverlayClassName="item-tooltip"
                            nzTooltipPlacement="top"
                            nzTooltipTitle="Enter the object name as a single value. If the name consists of multiple words, join them with underscores (e.g. my_object_name)"
                          />
                          <input
                            nz-input
                            class="form-control"
                            placeholder="example: value_1, value_2, value_3"
                            [(ngModel)]="pair.value"
                            [ngModelOptions]="{ standalone: true }"
                            nz-tooltip
                            nzTooltipOverlayClassName="item-tooltip"
                            nzTooltipPlacement="top"
                            nzTooltipTitle="Enter one or more values separated by commas (e.g. value_one, value_two, value_three)"
                          />
                        </div>
                      </div>
                    </ng-container>

                    <div
                      class="freewheel-kv-footer"
                      [class.end]="
                        editDspService.freewheelKeyValuePairs.length < 5
                      "
                    >
                      <span
                        *ngIf="editDspService.isFreewheelKvAtMax"
                        class="freewheel-kv-warning"
                      >
                        <span
                          nz-icon
                          nzType="info-circle"
                          nzTheme="outline"
                        ></span>
                        You can add only 5 addition fields
                      </span>
                      <button
                        nz-button
                        nzType="default"
                        class="freewheel-kv-add-btn"
                        [disabled]="editDspService.isFreewheelKvAtMax"
                        (click)="editDspService.addFreewheelKeyValuePair()"
                      >
                        <span nz-icon nzType="plus" nzTheme="outline"></span>
                        Add new field
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div
            class="form-group form-group_chb form-group_check no-m-b call-ep-url"
            *ngIf="
              editDspService.isRtbConnection() ||
              editDspService.isPreBidConnection()
            "
          >
            <div
              class="col-12 nurl_float_left"
              *ngIf="
                editDspService.isRtbConnection() ||
                editDspService.isPreBidConnection()
              "
            >
              <div class="form-group">
                <label class="label-title"
                  >Call DSP's NURL
                  <app-tooltip
                    [tooltipTitle]="'Call DSP\'s NURL'"
                  ></app-tooltip>
                </label>
                <nz-select
                  nzShowSearch
                  nzPlaceHolder="Select Nurl Options"
                  formControlName="nurl"
                  name="nurl"
                >
                  <nz-option
                    *ngFor="let nurl of editDspService.nurlOptions"
                    [nzValue]="nurl.id"
                    [nzLabel]="nurl.name"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
          </div>
          <div class="dsp-stat-wrap">
            <div class="form-group">
              <div class="row b-row">
                <div class="col-9" name="platformStatsApi">
                  <label for="dspStatApiLinkDSPEdit"
                    >DSP's Statistic API link</label
                  >
                  <input
                    nz-input
                    type="text"
                    class="form-control"
                    name="sspApiUrl"
                    id="dspStatApiLinkDSPEdit"
                    formControlName="apiLink"
                    (change)="
                      onValidateLink(
                        editDspService.formValue['apiLink'],
                        $event
                      )
                    "
                    placeholder="Place API link here"
                  />
                  <app-check-endpoint-status
                    [endpointValidationStatuses]="
                      editDspService.apiLinkValidationStatus
                    "
                    [apilink]="editDspService.apiLink"
                    [side]="'dsp'"
                    [endpointId]="data.endpointId"
                    (hasError)="getError($event)"
                  ></app-check-endpoint-status>
                  <small>replace date with a placeholder [%Y-m-d%]</small>
                </div>
                <div class="col-3">
                  <button
                    buttonLabel="testApiLinkDSPEdit"
                    class="test-link-button"
                    nz-button
                    nzType="default"
                    (click)="
                      onApiLinkTest(editDspService.formValue['apiLink'], $event)
                    "
                    [disabled]="editDspService.isDisabledTest"
                  >
                    Test
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row b-row dsp-api-link-wrap">
                <div class="col-9" name="platformStats">
                  <label>Platform Statistics API link</label>
                  <textarea
                    id="dspPlatformStatApiLinkDSPEdit"
                    nz-input
                    type="text"
                    disabled
                    [value]="editDspService.formValue['reportingApiLink']"
                    class="form-control"
                    name="dspApiUrl"
                  ></textarea>
                  <small>replace date with a placeholder [%Y-m-d%]</small>
                </div>
                <div class="col-3">
                  <button
                    buttonLabel="copyPlatformLinkDSPEdit"
                    nz-button
                    nzType="default"
                    type="button"
                    (click)="onLinkCopy($event, 'Copy API link')"
                    class="test-link-button"
                    [cbContent]="editDspService.formValue['reportingApiLink']"
                    ngxClipboard
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="editDspService.tabIndex === 2">
        <div class="schain-settings__row">
          <div class="schain-settings__title">Schain settings</div>
          <div class="schain-settings__subtitle">
            Select one Schain type to apply. Only a single option - SSP Schain,
            Platform Schain, or Source Schain can be active per endpoint.
          </div>
          <div
            class="schain-settings__column"
            qa="additionalSettings"
            customLabel="schainSettings"
          >
            <div class="check-tooltip">
              <label
                checkboxLabel="sspSchainEdit"
                nz-checkbox
                formControlName="isSspSchain"
                name="isSspSchain"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessageForEnterprise(
                    'SSP Schain'
                  )
                "
                nzTooltipPlacement="top"
                >SSP Schain</label
              >
              <app-tooltip
                tooltipTitle="Enabling this option ensures that only the original SSP request’s schain nodes are sent to the DSP.
              SSP requests with an empty schain object will be dropped"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                checkboxLabel="platformSchainEdit"
                nz-checkbox
                formControlName="sChain"
                name="sChain"
              >
                Platform Schain
              </label>
              <app-tooltip
                [tooltipTitle]="editDspService.sChainToolTipText"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="sourceSSPSchain"
                formControlName="is_ssp_schain_source"
                name="is_ssp_schain_source"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessageForEnterprise(
                    'SSP Source Schain'
                  )
                "
                nzTooltipPlacement="top"
                >SSP Source Schain</label
              >
              <app-tooltip
                [tooltipTitle]="editDspService.SSPSourceSchainToolTipText"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                nz-checkbox
                checkboxLabel="sourceDSPSchain"
                formControlName="schain_source"
                name="schain_source"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessageForEnterprise(
                    'DSP Source Schain'
                  )
                "
                nzTooltipPlacement="top"
                >DSP Source Schain</label
              >
              <app-tooltip
                [tooltipTitle]="editDspService.DSPSourceSchainToolTipText"
              ></app-tooltip>
            </div>
            <div class="check-tooltip">
              <label
                checkboxLabel="completeSchainEdit"
                nz-checkbox
                formControlName="is_schain_complete"
                name="is_schain_complete"
                >Complete Schain</label
              >
              <app-tooltip
                [tooltipTitle]="
                  'When the toggle is enabled, only requests with complete schain object will be passed to DSP'
                "
              ></app-tooltip>
            </div>
            <div
              class="check-tooltip"
              *ngIf="!editDspService.isPreBidConnection()"
            >
              <label
                nz-checkbox
                formControlName="is_dual_schain"
                name="is_dual_schain"
              >
                Process Dual Schain Objects
              </label>
              <app-tooltip [tooltipTitle]="dualSchainTooltip"></app-tooltip>
            </div>

            <div
              class="check-tooltip"
              *ngIf="editDspService.formValue.schain_source"
            >
              <label nz-checkbox formControlName="ipd_only" name="ipd_only">
                IPD Only
              </label>
              <app-tooltip
                tooltipTitle="When enabled, only the IPD will be added. ASI and SID values will be ignored, and Schain node will not be added."
              ></app-tooltip>
            </div>

            <div
              class="check-tooltip"
              *ngIf="editDspService.formValue.isSspSchain"
            >
              <label
                nz-checkbox
                formControlName="is_schain_complete"
                name="is_schain_complete"
              >
                Drop empty schain
              </label>
              <app-tooltip
                tooltipTitle="Drop the requests consisting the empty schain object"
              ></app-tooltip>
            </div>
            <div class="form-group" *ngIf="editDspService.isShowCustomSchain">
              <label>Custom schain</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Custom Schain"
                formControlName="schainCompany"
                name="schainCompany"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessageForEnterprise(
                    'Custom schain'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let schainValue of editDspService.schainValues"
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.sellerName"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              *ngIf="editDspService.isShowSchainNodeOrder"
            >
              <label>
                Schain Node Order
                <app-tooltip
                  tooltipTitle="Define the sequence in which the Platform and Custom Schain nodes are added to the DSP bid request."
                ></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Node Order"
                formControlName="schain_node_order"
                name="schain_node_order"
              >
                <nz-option
                  *ngFor="let order of editDspService.schainNodeOrderItems"
                  [nzValue]="order.id"
                  [nzLabel]="order.name"
                  nzCustomContent
                >
                  <span
                    class="item-name-container"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      order.isPresentSellerId ? '' : getTooltipTitle(order)
                    "
                    nzTooltipPlacement="top"
                  >
                    <span class="item-name">{{ order.name }}</span>
                    <span *ngIf="!order.isPresentSellerId" class="item-bracket"
                      >(
                      <span class="item-bracket-text">{{
                        order.isPresentSellerId ? "" : "No SID is found"
                      }}</span>
                      )</span
                    >
                  </span>
                </nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              selectLabel="schainModification"
              *ngIf="editDspService.isShowSourceFile"
            >
              <label> Source Schain File </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Source Schain File"
                formControlName="dsp_schain_source_file_id"
                name="dsp_schain_source_file_id"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessage('Source Schain File')
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let sourceSchain of editDspService.sourceSchainItems"
                  [nzValue]="sourceSchain.id"
                  [nzLabel]="sourceSchain.fileName"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              *ngIf="editDspService.isShowCustomSchainFilters"
            >
              <label>Schain modification</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Modification"
                formControlName="schain_filter_option"
                name="schain_filter_option"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessage(
                    'Schain modification'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let schainValue of editDspService.schainNodesFilters"
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.name"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              *ngIf="editDspService.isShowCustomSchainFilters"
            >
              <label>Complete Schain Status</label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Modification"
                formControlName="schain_complete_option"
                name="schain_complete_option"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessage(
                    'Complete Schain Status'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="let schainValue of editDspService.schainStatusItems"
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.name"
                ></nz-option>
              </nz-select>
            </div>
            <div
              class="form-group"
              *ngIf="editDspService.isShowCustomSchainFilters"
            >
              <label class="label-title" name="nodesLimitDropdown">
                Schain node limit filter

                <app-tooltip
                  tooltipTitle="Select the maximum number of SSP Schain nodes allowed in the bid request for this endpoint. 
                  Choosing “1 node”, for example, instructs the system to drop any SSP bid request containing more than 1 Schain node. 
                  Attekmi Schain node is automatically included and located after SSP Schain nodes"
                ></app-tooltip>
              </label>
              <nz-select
                nzShowSearch
                nzPlaceHolder="Select Schain Modification"
                formControlName="schain_limit"
                name="schain_limit"
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                [nzTooltipTitle]="
                  editDspService.restrictionTooltipMessage(
                    'Schain node limit filter'
                  )
                "
                nzTooltipPlacement="top"
              >
                <nz-option
                  *ngFor="
                    let schainValue of editDspService.schaninNodeLimitItems
                  "
                  [nzValue]="schainValue.id"
                  [nzLabel]="schainValue.name"
                ></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
        <div
          class="schain-authorization"
          *ngIf="editDspService.partnerSettings.schain_authorization"
        >
          <hr />
          <div class="schain-authorization__row">
            <div class="schain-authorization__title">
              Authorized Schain Only
            </div>
            <div class="schain-authorization__column">
              <div class="form-group form-group--schain-authorization">
                <label
                  nz-checkbox
                  formControlName="is_authorized_schain"
                  name="is_authorized_schain"
                  >Authorized Schain Only</label
                >
              </div>
              <div class="form-text">
                <p>
                  Allows only requests with schain nodes matching records in the
                  authorized sellers CSV. Available when the Schain
                  Authorization toggle (in Sellers.json Settings) and the
                  Platform Schain (in DSP EP settings) are enabled.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="editDspService.tabIndex === 3">
        <div class="col-6">
          <div
            class="dsp-scan-wrap"
            *ngIf="
              editDspService.partnerSettings.usePMPreBid &&
              editDspService.formValue['connectionType'] === 0
            "
          >
            <label class="form-title">Scanners</label>
            <div class="form-group">
              <label>Protected Media Suspisious IVT</label>
              <div class="perc-place">
                <nz-select
                  nzShowSearch
                  nzPlaceHolder="Select Item"
                  formControlName="pmPrebidSuspiciousIVT"
                  name="pmPrebidSuspiciousIVT"
                >
                  <nz-option
                    *ngFor="
                      let item of [
                        { id: 0, name: 'Allow' },
                        { id: 1, name: 'Block' },
                      ]
                    "
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
            <div class="form-group">
              <label>Protected Media Fraud IVT</label>
              <div class="perc-place">
                <nz-select
                  nzShowSearch
                  nzPlaceHolder="Select Item"
                  formControlName="pmPrebidFraudIVT"
                  name="pmPrebidFraudIVT"
                >
                  <nz-option
                    *ngFor="
                      let item of [
                        { id: 0, name: 'Allow' },
                        { id: 1, name: 'Block' },
                      ]
                    "
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
          </div>
          <div class="dsp-filters-wrap">
            <div
              class="form-group form-group_chb form-group_filcheck column-check"
            >
              <div
                class="check-tooltip-scanners"
                *ngIf="!editDspService.isJSConnection()"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="mismatchedIpFilterEdit"
                    nz-checkbox
                    formControlName="mismatchedIpFilter"
                    name="mismatchedIpFilter"
                  >
                    Mismatched IP Filter
                  </label>

                  <app-tooltip
                    tooltipTitle="The system will filter out requests with IPs on which more than 10% of mismatches are observed for the past 3 days.
                    By IP mismatches, we mean cases when the IP in the request and the IP on which impression happens are different"
                  ></app-tooltip>
                </div>
              </div>
              <div
                class="check-tooltip-scanners"
                *ngIf="!editDspService.isJSConnection()"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="mismatchedBundlesFiltersEdit"
                    nz-checkbox
                    formControlName="mismatchedBundlesFilters"
                    name="mismatchedBundlesFilters"
                    >Mismatched Bundle Filter</label
                  >

                  <app-tooltip
                    tooltipTitle="The system will filter out requests with bundles on which more than 10% of mismatches are observed for the past 3 days.
                  By bundle mismatches, we mean cases when the bundle in the request and the bundle on which impression happens are different"
                  ></app-tooltip>
                </div>
              </div>
              <div
                class="check-tooltip-scanners"
                *ngIf="!editDspService.isJSConnection()"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="iabOttCtvEdit"
                    nz-checkbox
                    formControlName="iabOttCtv"
                    name="iabOttCtv"
                    >IAB OTT/CTV compliance</label
                  >
                  <app-tooltip
                    [tooltipTitle]="
                      'Enabling the compliance with IAB OTT/CTV additional specification'
                    "
                  ></app-tooltip>
                </div>
              </div>
              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="useTCFEdit"
                    nz-checkbox
                    formControlName="useTCF"
                    (ngModelChange)="onChangeCheckedTCF($event)"
                    name="useTCF"
                    >TCF</label
                  >
                  <app-tooltip
                    [tooltipTitle]="
                      'Filter out requests without user consent or if the user consent isn\'t passed in compliance with the IAB TCF requirements'
                    "
                  ></app-tooltip>
                </div>
              </div>
              <div
                class="check-tooltip-scanners"
                *ngIf="editDspService.formValue['useTCF']"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="onlyWithConsentEdit"
                    nz-checkbox
                    formControlName="is_only_with_consent"
                    name="is_only_with_consent"
                  >
                    Only with consent

                    <app-tooltip
                      [tooltipTitle]="
                        'If enabled - only requests with gdpr=1 will be passed to this DSP endpoint'
                      "
                    ></app-tooltip>
                  </label>
                </div>
              </div>
              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="ccpaComplianceEdit"
                    nz-checkbox
                    formControlName="ccpa_check"
                    name="ccpa_check"
                    >CCPA compliance</label
                  >
                  <app-tooltip
                    tooltipTitle="This checkbox activates CCPA protocol for the DSP endpoint. If the request came from California, but without user consent, all personal data in the request will be anonymized"
                  ></app-tooltip>
                </div>
              </div>
              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="deviceIdRequiredEdit"
                    nz-checkbox
                    formControlName="deviceIdRequired"
                    name="deviceIdRequired"
                    >Only with IFA</label
                  >
                </div>

                <app-tooltip
                  [tooltipTitle]="
                    'If the request does not consist IFA, it will be dropped. All the valid IFA will be passed automatically'
                  "
                ></app-tooltip>
              </div>
              <div
                class="check-tooltip-scanners"
                *ngIf="editDspService.formValue['deviceIdRequired']"
              >
                <div class="checkbox">
                  <label
                    nz-checkbox
                    formControlName="allow_synth_ifa"
                    name="allow_synth_ifa"
                    >Allow the synthetic IFA</label
                  >
                </div>
                <app-tooltip
                  [tooltipTitle]="
                    'In case the request consists synthetic IFA, it will be passed'
                  "
                ></app-tooltip>
              </div>
              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="placementRequiredEdit"
                    nz-checkbox
                    formControlName="withPlacementOnly"
                    name="withPlacementOnly"
                    >Placement required</label
                  >
                </div>
                <app-tooltip
                  [tooltipTitle]="
                    'Attekmi will filter out the requests not including “placement“ or “plcmt“ parameter'
                  "
                ></app-tooltip>
              </div>

              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="ipv4RequiredEdit"
                    nz-checkbox
                    formControlName="ipv4_required"
                    name="ipv4_required"
                  >
                    IPv4 required
                  </label>

                  <app-tooltip
                    [tooltipTitle]="
                      'Attekmi will filter out requests without IPv4'
                    "
                  ></app-tooltip>
                </div>
              </div>

              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="badvLimitEdit"
                    nz-checkbox
                    formControlName="has_badv_limit"
                    name="has_badv_limit"
                  >
                    BADV limit
                  </label>
                </div>
                <app-tooltip
                  tooltipTitle="If you want to limit the number of entries for badv sent to the DSPs, please enable the checkbox.
                  It will mean that platform cuts some entries and send only 49 blocked categories and domains."
                ></app-tooltip>
              </div>

              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="iabCategoriesLimitEdit"
                    nz-checkbox
                    formControlName="has_iab_categories_limit"
                    name="has_iab_categories_limit"
                  >
                    IAB sub-categories limit
                  </label>
                </div>
                <app-tooltip
                  tooltipTitle="If you want to limit the number of IAB categories sent to the DSPs, please enable the checkbox.
                  It will mean that platform cuts all the IAB sub-categories from the request passed to the DSP."
                ></app-tooltip>
              </div>

              <div
                class="check-tooltip-scanners"
                *ngIf="
                  editDspService.isRtbConnection() ||
                  editDspService.isPreBidConnection()
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="onlyWithAppNameEdit"
                    nz-checkbox
                    formControlName="is_requests_empty_appname"
                    name="is_requests_empty_appname"
                    nz-tooltip
                    nzTooltipOverlayClassName="item-tooltip"
                    [nzTooltipTitle]="
                      editDspService.restrictionTooltipMessageForEnterprise(
                        'Only with app name'
                      )
                    "
                    nzTooltipPlacement="top"
                  >
                    Only with app name
                  </label>
                </div>
                <app-tooltip
                  [tooltipTitle]="
                    'Enable this option to ensure only requests with app names are sent to DSPs'
                  "
                ></app-tooltip>
              </div>

              <div
                class="check-tooltip-scanners"
                *ngIf="
                  editDspService.isRtbConnection() ||
                  editDspService.isPreBidConnection()
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="excludeMraidResponseEdit"
                    nz-checkbox
                    name="exclude_mraid_response"
                    formControlName="exclude_mraid_response"
                  >
                    Exclude mraid.js responses
                  </label>
                </div>
                <app-tooltip [tooltipTitle]="mraidTooltip"></app-tooltip>
              </div>

              <div
                class="check-tooltip-scanners"
                *ngIf="
                  editDspService.isRtbConnection() ||
                  editDspService.isPreBidConnection()
                "
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="mraidImpressionPixelEdit"
                    nz-checkbox
                    formControlName="mraid_impression_pixel"
                    name="mraid_impression_pixel"
                  >
                    Add mraid.js impression pixel
                  </label>
                </div>
                <app-tooltip
                  [tooltipTitle]="
                    'To add mraid.js impression pixel to the ADM in the DSP response'
                  "
                ></app-tooltip>
              </div>

              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    nz-checkbox
                    formControlName="is_coppa_filtration"
                    name="is_coppa_filtration"
                  >
                    COPPA Filtration
                  </label>
                </div>
                <app-tooltip
                  tooltipTitle="Filters requests by COPPA value. Only requests matching the selected COPPA option (0 or 1) will be sent to DSP, others will be dropped."
                ></app-tooltip>
              </div>

              <div
                class="input-group"
                *ngIf="editDspService.formValue['is_coppa_filtration']"
              >
                <nz-select
                  nzShowSearch
                  formControlName="coppa_filter"
                  name="coppa_filter"
                >
                  <nz-option
                    *ngFor="let item of editDspService.coppaFilterItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    nz-checkbox
                    formControlName="is_lmt_and_dnt_filter"
                    name="is_lmt_and_dnt_filter"
                  >
                    LMT & DNT Filter
                  </label>
                </div>
                <app-tooltip
                  [tooltipTitle]="lmtAndDntFilterTooltip"
                ></app-tooltip>
              </div>

              <div
                class="input-group"
                *ngIf="editDspService.formValue['is_lmt_and_dnt_filter']"
              >
                <nz-select
                  nzShowSearch
                  formControlName="lmt_and_dnt_filter"
                  name="lmt_and_dnt_filter"
                >
                  <nz-option
                    *ngFor="let item of editDspService.lmtAndDntFilterItems"
                    [nzValue]="item.id"
                    [nzLabel]="item.name"
                  ></nz-option>
                </nz-select>
              </div>

              <div
                class="check-tooltip-scanners"
                *ngIf="isBotmanPostBidIsEnabled"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="botmanPostBidDSPEdit"
                    nz-checkbox
                    qa="scanner"
                    name="botman_enable_postbid"
                    formControlName="botman_enable_postbid"
                    >Botman (Post-bid)</label
                  >
                </div>
              </div>

              <div
                class="check-tooltip-scanners"
                *ngIf="isHumanFraudsensorEnabled()"
              >
                <div class="checkbox">
                  <label
                    checkboxLabel="humanFraudsensorPostBidDSPEdit"
                    nz-checkbox
                    qa="scanner"
                    formControlName="fraud_sensor_enable_postbid"
                    name="fraud_sensor_enable_postbid"
                    >Human FraudSensor (Post-bid)</label
                  >
                </div>
              </div>

              <div class="check-tooltip-scanners" *ngIf="isFraudLogixEnabled()">
                <div class="checkbox">
                  <label
                    checkboxLabel="fraudLogixPostBidDSP"
                    nz-checkbox
                    formControlName="fraud_logix_enable_postbid"
                    name="fraud_logix_enable_postbid"
                  >
                    Fraudlogix (Post-bid)
                  </label>
                </div>
              </div>

              <div class="check-tooltip-scanners">
                <div class="checkbox">
                  <label
                    checkboxLabel="pixalatePostBidDSPEdit"
                    nz-checkbox
                    *ngIf="editDspService.partnerSettings.usePixalate"
                    qa="scanner"
                    formControlName="is_pixalate_postbid"
                    name="is_pixalate_postbid"
                    >Pixalate (Post-bid)</label
                  >
                </div>
              </div>
              <div
                customLabel="pixalatePrebidBlockDSPEdit"
                class="pixalate-checkbox-wrapper"
                *ngIf="
                  editDspService.partnerSettings.pixalate_pb_settings &&
                  editDspService.partnerSettings.usePixalatePrebid &&
                  !editDspService.isJSConnection()
                "
                formGroupName="pixalate_pb_settings"
              >
                <div
                  *ngIf="editDspService.partnerSettings.pixalate_pb_settings.ip"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidIpDSPEdit"
                      nz-checkbox
                      formControlName="ip"
                      name="pixalate_pb_settings.ip"
                      >Pixalate Pre-bid IP filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editDspService.formValue.pixalate_pb_settings.ip"
                  >
                    <label>Pixalate IP IVT Percent</label>
                    <input
                      id="pixalateIpPercentDSPEdit"
                      nz-input
                      min="0"
                      max="100"
                      type="number"
                      name="pixalate_pb_settings.ip_percent"
                      formControlName="ip_percent"
                      (keyup)="onPreventInput($event, 'ip_percent')"
                      (click)="onPreventInput($event, 'ip_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    editDspService.partnerSettings.pixalate_pb_settings.ifa
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidIfaDSPEdit"
                      nz-checkbox
                      formControlName="ifa"
                      name="pixalate_pb_settings.ifa"
                      >Pixalate Pre-bid IFA filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editDspService.formValue.pixalate_pb_settings.ifa"
                  >
                    <label>Pixalate IFA IVT Percent</label>
                    <input
                      id="pixalateIFAIVTPercentDSPEdit"
                      nz-input
                      min="0"
                      max="100"
                      type="number"
                      name="pixalate_pb_settings.ifa_percent"
                      formControlName="ifa_percent"
                      (keyup)="onPreventInput($event, 'ifa_percent')"
                      (click)="onPreventInput($event, 'ifa_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="editDspService.partnerSettings.pixalate_pb_settings.ua"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidUaDSPEdit"
                      nz-checkbox
                      formControlName="ua"
                      name="pixalate_pb_settings.ua"
                      >Pixalate Pre-bid UA filter</label
                    >
                  </div>
                </div>
                <div
                  *ngIf="
                    editDspService.partnerSettings.pixalate_pb_settings.ott
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidOttDSPEdit"
                      nz-checkbox
                      formControlName="ott"
                      name="pixalate_pb_settings.ott"
                      >Pixalate Pre-bid OTT filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editDspService.formValue.pixalate_pb_settings.ott"
                  >
                    <label>Pixalate OTT IVT Percent</label>
                    <input
                      id="pixalateOttPercentDSPEdit"
                      nz-input
                      min="0"
                      max="100"
                      type="number"
                      name="pixalate_pb_settings.ott_percent"
                      formControlName="ott_percent"
                      (keyup)="onPreventInput($event, 'ott_percent')"
                      (click)="onPreventInput($event, 'ott_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    editDspService.partnerSettings.pixalate_pb_settings.def_app
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidDefAppDSPEdit"
                      nz-checkbox
                      formControlName="def_app"
                      name="pixalate_pb_settings.def_app"
                      >Pixalate Pre-bid Defased App filter</label
                    >
                  </div>
                </div>
                <div
                  *ngIf="
                    editDspService.partnerSettings.pixalate_pb_settings.domain
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidDomainDSPEdit"
                      nz-checkbox
                      formControlName="domain"
                      name="pixalate_pb_settings.domain"
                      >Pixalate Pre-bid Domain filter</label
                    >
                  </div>
                </div>
                <div
                  *ngIf="
                    editDspService.partnerSettings.pixalate_pb_settings.hr_app
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidBundleDSPEdit"
                      nz-checkbox
                      formControlName="hr_app"
                      name="pixalate_pb_settings.hr_app"
                      >Pixalate Pre-bid Bundle filter</label
                    >
                  </div>
                  <div
                    class="input-group"
                    *ngIf="editDspService.formValue.pixalate_pb_settings.hr_app"
                  >
                    <label>Pixalate Bundle IVT Percent</label>
                    <input
                      id="pixalateBundleIVTPercentDSPEdit"
                      nz-input
                      min="0"
                      max="100"
                      type="number"
                      name="pixalate_pb_settings.hr_app_percent"
                      formControlName="hr_app_percent"
                      (keyup)="onPreventInput($event, 'hr_app_percent')"
                      (click)="onPreventInput($event, 'hr_app_percent')"
                      class="form-control"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    editDspService.partnerSettings.pixalate_pb_settings
                      .dc_subnet
                  "
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="pixalatePrebidDcSubnetDSPEdit"
                      nz-checkbox
                      formControlName="dc_subnet"
                      name="pixalate_pb_settings.dc_subnet"
                      >Pixalate Pre-bid Data Center IP filter</label
                    >
                  </div>
                </div>
              </div>
              <div class="selects-block">
                <div class="selects-block__column">
                  <div class="form-group">
                    <label>Secure</label>
                    <nz-select
                      nzShowSearch
                      formControlName="secureOnly"
                      name="secureOnly"
                    >
                      <nz-option
                        *ngFor="let option of editDspService.secureOptions"
                        [nzValue]="option.id"
                        [nzLabel]="option.name"
                      >
                      </nz-option>
                    </nz-select>
                  </div>
                </div>

                <div class="selects-block__column">
                  <div class="form-group">
                    <label>
                      Adult Filter
                      <app-tooltip
                        [tooltipTitle]="adultFilterTooltip"
                      ></app-tooltip>
                    </label>
                    <nz-select
                      nzShowSearch
                      formControlName="filterPorn"
                      name="filterPorn"
                    >
                      <nz-option
                        *ngFor="let option of editDspService.pornFilter"
                        [nzValue]="option.id"
                        [nzLabel]="option.name"
                      >
                      </nz-option>
                    </nz-select>
                  </div>
                </div>
              </div>

              <div class="form-title form-title--additional">
                Additional Settings
              </div>
              <div
                class="form-group form-group_chb form-group_filcheck column-check"
              >
                <div
                  class="check-tooltip-scanners"
                  *ngIf="editDspService.isShowVastAdditionalSettings()"
                >
                  <div class="checkbox">
                    <label
                      nz-checkbox
                      formControlName="is_store_url"
                      name="is_store_url"
                      >Add Store URL</label
                    >
                  </div>
                  <app-tooltip [tooltipTitle]="tooltipTemplate"></app-tooltip>
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="editDspService.isShowRtbAdditionalSettings()"
                >
                  <div class="checkbox">
                    <label
                      checkboxLabel="omsdk"
                      nz-checkbox
                      formControlName="is_omsdk"
                      name="is_omsdk"
                      >Pass OMSDK</label
                    >
                  </div>
                  <app-tooltip
                    [tooltipTitle]="
                      'If you would like to pass OMSDK parameters to the DSP, please select this checkbox. In case the checkbox is deactivated, OMSDK parameters will be removed from the bid request even if we receive them in the original request from SSP.'
                    "
                  ></app-tooltip>
                </div>

                <div
                  class="check-tooltip-scanners"
                  *ngIf="editDspService.isShowRtbAdditionalSettings()"
                >
                  <div class="checkbox">
                    <label
                      nz-checkbox
                      formControlName="is_display_manager"
                      name="is_display_manager"
                      >Pass Display Manager</label
                    >
                  </div>
                  <app-tooltip
                    tooltipTitle="Controls whether displaymanager fields are passed to the DSP.
                When enabled, displaymanager and displaymanagerver will be forwarded if received from the SSP.
                When disabled, these fields will be removed from the outgoing request if received from the SSP."
                  ></app-tooltip>
                </div>

                <div class="check-tooltip-scanners">
                  <div class="checkbox">
                    <label
                      nz-checkbox
                      formControlName="is_pchain"
                      name="is_pchain"
                      >Pass Pchain</label
                    >
                  </div>
                  <app-tooltip
                    tooltipTitle="Controls whether the pchain field is passed to the DSP.
                  When enabled, the platform will include the pchain field if the data was received from the SSP.
                  When disabled, pchain field will be removed from the outgoing request. This option becomes available only when at least one Schain type is activated."
                  ></app-tooltip>
                </div>
              </div>

              <div
                class="form-group"
                *ngIf="editDspService.filterLists.length > 0"
              >
                <label>Filter Lists</label>
                <nz-select
                  nzMode="multiple"
                  formControlName="filter_list_ids"
                  nzPlaceHolder="Select Filter List(s)"
                  nzShowSearch
                  [nzShowArrow]="true"
                  name="filter_list_ids"
                  [nzMaxTagCount]="10"
                >
                  <nz-option-group
                    *ngFor="let itemGroup of editDspService.filterLists"
                    [nzLabel]="itemGroup.item_group"
                  >
                    <nz-option
                      *ngFor="let item of itemGroup.items"
                      [nzValue]="item.id"
                      [nzLabel]="item.name + ': ' + item.count + ' item(s)'"
                      [nzDisabled]="!!item.is_all_dsp"
                    ></nz-option>
                  </nz-option-group>
                </nz-select>
              </div>
              <div class="clearfix">
                <div
                  class="part left alt"
                  *ngIf="
                    editDspService.isRtbConnection() && botmanPreBidIsEnabled()
                  "
                >
                  <div class="form-group filter-group">
                    <label>Botman Pre-bid IVT</label>
                    <nz-select
                      nzShowSearch
                      nzPlaceHolder="Select Item"
                      formControlName="botman_allow_fraud"
                      name="botman_allow_fraud"
                    >
                      <nz-option
                        *ngFor="
                          let trigger of editDspService.allowCountriesTrigger
                        "
                        [nzValue]="trigger.id"
                        [nzLabel]="trigger.name"
                      ></nz-option>
                    </nz-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="row b-row">
              <div class="col-12">
                <label class="label-title"
                  >Countries
                  <app-tooltip
                    [tooltipTitle]="
                      'Choose allowed/blocked countries for this endpoint'
                    "
                  ></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue['countriesTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['countriesTrigger'] === 0
                  "
                  formControlName="countriesTrigger"
                  name="countriesTrigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-tree-select
                  name="countriesList"
                  nzPlaceHolder="Select Country(s)"
                  nzPlacement="bottomRight"
                  [nzDropdownStyle]="{ width: '400px' }"
                  [class.allowed-filter]="
                    editDspService.formValue['countriesTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['countriesTrigger'] === 0
                  "
                  formControlName="countriesList"
                  [nzMaxTagCount]="7"
                  [nzMaxTagPlaceholder]="omittedCountriesPlaceHolder"
                  [nzNodes]="editDspService.countriesItems"
                  [nzAllowClear]="false"
                  [nzShowSearch]="true"
                  [nzMultiple]="true"
                  nzVirtualHeight="250px"
                  nzCheckable
                  [nzTreeTemplate]="customCountriesTpl"
                  [nzHideUnMatched]="true"
                ></nz-tree-select>
                <ng-template #omittedCountriesPlaceHolder let-omittedValues
                  >and {{ omittedValues.length }} more...</ng-template
                >
                <ng-template #customCountriesTpl let-item>
                  {{ item.title }}
                </ng-template>
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="editDspService.isShowStatesControl()">
            <div class="row b-row">
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue['states_trigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['states_trigger'] === 0
                  "
                  formControlName="states_trigger"
                  name="states_trigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  ></nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-select
                  nzShowSearch
                  [nzShowArrow]="true"
                  nzPlaceHolder="Select State(s)"
                  [class.allowed-filter]="
                    editDspService.formValue['states_trigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['states_trigger'] === 0
                  "
                  formControlName="statesList"
                  name="statesList"
                  nzMode="multiple"
                  [nzFilterOption]="editDspService.filterStatesList"
                >
                  <nz-option
                    *ngFor="let list of editDspService.statesList"
                    [nzValue]="list.id"
                    [nzLabel]="list.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
            </div>

            <div class="row b-row" *ngIf="editDspService.isShowStatesControl()">
              <div class="switch-wrap__row">
                <div class="switch-wrap__column column-switch">
                  <div class="column-switch__label">
                    <span>Allow processing of undefined U.S. states</span>
                    <div class="icon">
                      <app-tooltip
                        tooltipTitle="If enabled, the system will allow traffic from U.S. requests where the state could not be identified. If left unchecked, requests with undefined states will be dropped"
                      ></app-tooltip>
                    </div>
                  </div>
                  <div class="column-switch__switch">
                    <nz-switch
                      formControlName="is_undefined_state_allowed"
                      name="is_undefined_state_allowed"
                    ></nz-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row b-row">
              <div class="col-12">
                <label class="label-title"
                  >SSPs
                  <app-tooltip
                    [tooltipTitle]="
                      'Choose allowed/blocked SSPs for this endpoint'
                    "
                  ></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue['sspTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['sspTrigger'] === 0
                  "
                  name="sspTrigger"
                  formControlName="sspTrigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-tree-select
                  name="dspList"
                  nzPlaceHolder="Select SSP Endpoint(s)"
                  nzPlacement="bottomRight"
                  [nzDropdownStyle]="{ width: '300px' }"
                  [class.allowed-filter]="
                    editDspService.formValue['sspTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['sspTrigger'] === 0
                  "
                  formControlName="sspList"
                  [nzMaxTagCount]="3"
                  [nzMaxTagPlaceholder]="omittedPlaceHolder"
                  [nzNodes]="editDspService.companiesSSPDropdown"
                  [nzAllowClear]="false"
                  [nzShowSearch]="true"
                  [nzMultiple]="true"
                  nzVirtualHeight="250px"
                  nzCheckable
                  [nzTreeTemplate]="customTpl"
                  [nzHideUnMatched]="true"
                ></nz-tree-select>
                <ng-template #omittedPlaceHolder let-omittedValues
                  >and {{ omittedValues.length }} more...</ng-template
                >
                <ng-template #customTpl let-item>
                  {{ item.title | trunc: [20] }}
                </ng-template>
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="editDspService.isShowVideoSizes">
            <div class="row b-row" formGroupName="presetPlayerSizes">
              <div class="col-12">
                <label class="label-title"
                  >Video Width Presets
                  <app-tooltip
                    [tooltipTitle]="videoWidthPresetsTooltip"
                  ></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue.presetPlayerSizes.trigger === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue.presetPlayerSizes.trigger === 0
                  "
                  [class.disabled-filter]="
                    editDspService.presetVideoSizeControl.disabled
                  "
                  name="videoWidthPresetsTrigger"
                  formControlName="trigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-select
                  nzShowSearch
                  [nzShowArrow]="true"
                  nzPlaceHolder="Select Video Width Preset(s)"
                  [class.allowed-filter]="
                    editDspService.formValue.presetPlayerSizes.trigger === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue.presetPlayerSizes.trigger === 0
                  "
                  [class.disabled-filter]="
                    editDspService.presetVideoSizeControl.disabled
                  "
                  formControlName="size"
                  name="playerSizes"
                  nzMode="multiple"
                >
                  <nz-option
                    *ngFor="let list of editDspService.playerSizes"
                    [nzValue]="list.id"
                    [nzLabel]="list.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="editDspService.isShowVideoSizes">
            <div class="row b-row" formGroupName="playerSizes">
              <div class="col-12">
                <label class="label-title"
                  >Video Sizes
                  <app-tooltip [tooltipTitle]="videoSizesTooltip"></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue.playerSizes.trigger === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue.playerSizes.trigger === 0
                  "
                  [class.disabled-filter]="
                    editDspService.videoSizeControl.disabled
                  "
                  name="videoSizeTrigger"
                  formControlName="trigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  ></nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-select
                  nzShowSearch
                  [nzShowArrow]="true"
                  nzPlaceHolder="Select Video Size(s)"
                  [class.allowed-filter]="
                    editDspService.formValue.playerSizes.trigger === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue.playerSizes.trigger === 0
                  "
                  [class.disabled-filter]="
                    editDspService.videoSizeControl.disabled
                  "
                  formControlName="size"
                  name="videoSizeList"
                  nzMode="multiple"
                  [nzDropdownRender]="sizeTemplate"
                >
                  <nz-option
                    *ngFor="let list of editDspService.videoSizesList"
                    [nzValue]="list.id"
                    [nzLabel]="list.name"
                  ></nz-option>
                </nz-select>
                <ng-template #sizeTemplate>
                  <nz-divider></nz-divider>
                  <div class="container">
                    <input
                      type="text"
                      nz-input
                      #inputElement
                      placeholder="Width x Height"
                      (keypress)="onValidateSize($event)"
                      style="border-radius: 8px; border-color: #00a79d"
                    />
                    <button
                      nz-button
                      nzType="primary"
                      class="add-item"
                      (click)="
                        onAddCustomSize(
                          inputElement,
                          editDspService.videoSizesList
                        )
                      "
                    >
                      Add
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="editDspService.isShowBannerSizes">
            <div class="row b-row">
              <div class="col-12">
                <label class="label-title"
                  >Banner Sizes
                  <app-tooltip
                    [tooltipTitle]="bannerSizesTooltip"
                  ></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue['sizeTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['sizeTrigger'] === 0
                  "
                  name="sizeTrigger"
                  formControlName="sizeTrigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  ></nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-select
                  nzShowSearch
                  [nzShowArrow]="true"
                  nzPlaceHolder="Select Banner Size(s)"
                  [class.allowed-filter]="
                    editDspService.formValue['sizeTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['sizeTrigger'] === 0
                  "
                  formControlName="sizesList"
                  name="sizeList"
                  nzMode="multiple"
                  [nzDropdownRender]="sizeTemplate"
                >
                  <nz-option
                    *ngFor="let list of editDspService.sizesList"
                    [nzValue]="list.id"
                    [nzLabel]="list.name"
                  ></nz-option>
                </nz-select>
                <ng-template #sizeTemplate>
                  <nz-divider></nz-divider>
                  <div class="container">
                    <input
                      type="text"
                      nz-input
                      #inputElement
                      placeholder="Width x Height"
                      (keypress)="onValidateSize($event)"
                      style="border-radius: 8px; border-color: #00a79d"
                    />
                    <button
                      nz-button
                      nzType="primary"
                      class="add-item"
                      (click)="
                        onAddCustomSize(inputElement, editDspService.sizesList)
                      "
                    >
                      Add
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row b-row">
              <div class="col-12">
                <label class="label-title"
                  >Connection Types
                  <app-tooltip
                    [tooltipTitle]="
                      'Choose allowed/blocked connection types for this endpoint'
                    "
                  ></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue['connectionTypeTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['connectionTypeTrigger'] === 0
                  "
                  name="connectionTypeTrigger"
                  formControlName="connectionTypeTrigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  ></nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-select
                  nzShowSearch
                  [nzShowArrow]="true"
                  nzPlaceHolder="Select Connection Type(s)"
                  [class.allowed-filter]="
                    editDspService.formValue['connectionTypeTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['connectionTypeTrigger'] === 0
                  "
                  formControlName="connectionTypesList"
                  name="connectionTypesList"
                  nzMode="multiple"
                >
                  <nz-option
                    *ngFor="let list of editDspService.connectionTypes"
                    [nzValue]="list.id"
                    [nzLabel]="list.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row b-row">
              <div class="col-12">
                <label class="label-title"
                  >Device OS
                  <app-tooltip
                    [tooltipTitle]="
                      'Choose allowed/blocked device OS for this endpoint'
                    "
                  ></app-tooltip>
                </label>
              </div>
              <div class="col-4">
                <nz-select
                  [class.allowed-filter]="
                    editDspService.formValue['osTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['osTrigger'] === 0
                  "
                  name="osTrigger"
                  formControlName="osTrigger"
                >
                  <nz-option
                    *ngFor="let trigger of editDspService.allowCountriesTrigger"
                    [nzValue]="trigger.id"
                    [nzLabel]="trigger.name"
                  ></nz-option>
                </nz-select>
              </div>
              <div class="col-8">
                <nz-select
                  nzShowSearch
                  [nzShowArrow]="true"
                  nzPlaceHolder="Select Operation System(s)"
                  [class.allowed-filter]="
                    editDspService.formValue['osTrigger'] === 1
                  "
                  [class.blocked-filter]="
                    editDspService.formValue['osTrigger'] === 0
                  "
                  formControlName="osList"
                  name="osList"
                  nzMode="multiple"
                >
                  <nz-option
                    *ngFor="let list of editDspService.osList"
                    [nzValue]="list.id"
                    [nzLabel]="list.name"
                  >
                  </nz-option>
                </nz-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="editDspService.tabIndex === 4">
        <div class="col-6">
          <div class="form-title">Others</div>
          <div class="other-wrap">
            <div class="form-group">
              <label for="emailDSPEdit">Contact Email</label>
              <input
                nz-input
                class="form-control"
                id="emailDSPEdit"
                name="email"
                email
                type="email"
                formControlName="email"
              />
            </div>
            <div class="form-group">
              <label for="commentsDSPEdit">Comment</label>
              <input
                nz-input
                class="form-control"
                id="commentsDSPEdit"
                name="comments"
                formControlName="comments"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *nzModalFooter class="form-bottom">
      <div class="form-bottom__buttons">
        <div class="buttons-block">
          <span
            class="buttons-block__item"
            nz-tooltip
            nzTooltipOverlayClassName="item-tooltip"
            [nzTooltipTitle]="
              editDspService.restrictionTooltipMessageForButton(
                editDspService.formValue.connectionType
              )
            "
          >
            <button
              type="submit"
              nz-button
              class="btn-save"
              nzType="primary"
              [disabled]="editDspService.isDisabledSubmitBtn"
              (click)="onFormSubmit()"
            >
              Save
            </button>
          </span>
          <span class="buttons-block__item">
            <button
              type="button"
              nz-button
              class="btn-cancel"
              nzType="default"
              (click)="onCloseModal()"
            >
              Cancel
            </button>
          </span>
        </div>
        <ng-container *ngIf="!editDspService.isUserViewer">
          <div
            class="icons-block"
            [style.width]="
              !editDspService.formValue.deletedAt ? '70px' : 'auto'
            "
          >
            <button
              buttonLabel="duplicateEndpointDSP"
              nz-button
              nzType="text"
              class="btn-duplicate"
              [disabled]="editDspService.isDisableDuplicate"
              (click)="onDuplicateEndpoint(data.endpointId)"
            >
              <span nz-icon class="icons-block__icon">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_12897_68458)">
                    <rect width="32" height="32" rx="4" fill="white" />
                    <rect
                      width="32"
                      height="32"
                      rx="4"
                      fill="url(#paint0_linear_12897_68458)"
                    />
                    <path
                      d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H28C29.933 0.5 31.5 2.067 31.5 4V28C31.5 29.933 29.933 31.5 28 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z"
                      stroke="#D8DDE6"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.7894 7H9.68421C8.75789 7 8 7.77727 8 8.72727V20.8182H9.68421V8.72727H19.7894V7Z"
                      fill="#A8B7C7"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.0533 10.4551H22.3165C23.2428 10.4551 24.0007 11.2324 24.0007 12.1823V24.2733C24.0007 25.2233 23.2428 26.0005 22.3165 26.0005H13.0533C12.127 26.0005 11.3691 25.2233 11.3691 24.2733V12.1823C11.3691 11.2324 12.127 10.4551 13.0533 10.4551ZM13.0533 24.2731H22.3165V12.1822H13.0533V24.2731Z"
                      fill="#A8B7C7"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_12897_68458"
                      x1="16"
                      y1="0"
                      x2="16"
                      y2="32"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                    <clipPath id="clip0_12897_68458">
                      <rect width="32" height="32" rx="4" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </button>
            <span
              buttonLabel="deleteEndpointDSP"
              nz-icon
              (click)="onDeleteEndpoint(editDspService.formValue)"
              class="icons-block__icon"
              *ngIf="!editDspService.formValue.deletedAt"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_12897_68475)">
                  <rect width="32" height="32" rx="4" fill="white" />
                  <rect
                    width="32"
                    height="32"
                    rx="4"
                    fill="url(#paint0_linear_12897_68475)"
                  />
                  <path
                    d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H28C29.933 0.5 31.5 2.067 31.5 4V28C31.5 29.933 29.933 31.5 28 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z"
                    stroke="#D8DDE6"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 23C10 24.1 10.9 25 12 25H20C21.1 25 22 24.1 22 23V11H10V23Z"
                    fill="#A8B7C7"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M23 8H19.5L18.5 7H13.5L12.5 8H9V10H23V8Z"
                    fill="#A8B7C7"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_12897_68475"
                    x1="16"
                    y1="0"
                    x2="16"
                    y2="32"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                  <clipPath id="clip0_12897_68475">
                    <rect width="32" height="32" rx="4" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</form>

<ng-template #dualSchainTooltip>
  <div class="tooltip-body">
    <div>
      Enable this option to process both source.schain (OpenRTB 2.6) and
      source.ext.schain (OpenRTB 2.5) objects if both are present in incoming
      SSP requests.
    </div>
    <div>
      The platform will apply internal logic to determine whether to preserve,
      merge, or discard one of the objects before forwarding to the DSP.
    </div>
    <br />
    <br />
    For detailed logic and examples, please refer to our
    <span (click)="createDspService.openLink()" class="article-link"
      >Knowledgebase article</span
    >
  </div>
</ng-template>

<ng-template #adultFilterTooltip>
  <div class="tooltip-body">
    <p class="tooltip-body__title">
      Choose how adult-oriented inventory should be handled:
    </p>
    <ul class="tooltip-body__list">
      <li>
        <b>Allow All Traffic</b>
        - Allow both adult and non-adult traffic
      </li>
      <li>
        <b>Exclude Adult</b>
        – Filter out all adult-oriented sources.
      </li>
      <li>
        <b>Only Adult</b>
        – Allow only adult-oriented sources.
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #tooltipTemplate>
  <p class="tooltip-body">
    When enabled, the system will automatically populate the store URL if it's
    missing in the incoming SSP request. The bundle ID from the request will be
    used to generate the store URL as follows:
    <br /><span class="article-link">
      <strong>Android:</strong> {{ androidTooltipUrl }}
    </span>
    <br /><span class="article-link">
      <strong>iOS:</strong> {{ iosTooltipUrl }}
    </span>
  </p>
</ng-template>

<ng-template #lmtAndDntFilterTooltip>
  <div class="tooltip-body">
    <p class="tooltip-body__title">
      When this filter is enabled, incoming requests with privacy flags (LMT or
      DNT) can be excluded based on your selection:
    </p>

    <ul class="tooltip-body__list">
      <li>
        <b>Exclude All</b>
        - Drops all requests where LMT=1 or DNT=1
      </li>
      <li>
        <b>Exclude LMT=1</b>
        – Drops only requests with LMT=1
      </li>
      <li>
        <b>Exclude DNT=1</b>
        – Drops only requests with DNT=1
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #videoWidthPresetsTooltip>
  <div class="tooltip-body">
    Allow or block <span>ranges</span> of video player dimensions using
    <span>presets</span>. <br />
    Choose from prebuilt rules (e.g.
    <span>Block sizes smaller than < 250 px</span>). <br />
    Note: Selecting any preset here <span>"Video Sizes" dropdown</span>.
  </div>
</ng-template>

<ng-template #bannerSizesTooltip>
  <div class="tooltip-body">
    Allow or block <span>specific banner sizes</span>. <br />
    Choose from presets or add a custom size in <span>WxH</span> format (e.g.,
    <span>300x250</span>, <span>150x150</span>). <br />
    This filter applies only when the <span>Banner</span> ad format is selected.
  </div>
</ng-template>

<ng-template #videoSizesTooltip>
  <div class="tooltip-body">
    Allow or block <span>specific</span> video player sizes (e.g.,
    <span>640x360</span>, <span>1920x1080</span>). <br />
    Pick from presets or add a custom size in <span>WxH</span> format. <br />
    Note: Selecting any size here
    <span>disables "Video Width Presets"</span> dropdown.
  </div>
</ng-template>
